const ComponentBase = require('../base/ComponentBase');
const AppEvent = require('../misc/AppEvent');
/**
 * 数据访问器
 * @typedef G.render.RenderMgr~FeatureVisitor
 * @type {Object}
 * @property {Function} visit 遍历器
 * @example
 * {
 *   visit: function(element,layer){
 *          //
 *          console.log(element);
 *          // 返回true继续遍历，返回false则终止
 *          return true;
 *      }
 * }
 *
 */

/**
 * @constructor
 * @classdesc 渲染管理器
 * @augments G.base.ComponentBase
 * @alias G.render.RenderMgr
 * @param {Object} options  构造参数；
 * @param {G.Map} options.map  地图对象
 */
let component = ComponentBase.extend({
    options: {},
    initialize(options) {
        ComponentBase.prototype.initialize.call(this, options);
        //添加的资源类型
        this.featureTypeList = [];
        //监听的事件
        this.listenEvents = {};
        //
        this._last_mouse_over = null;
        //
        let that = this;
        this.eventDispatcher = {
            listens: (event) => {
                return that.listens(event);
            },
            listener(featureType, event) {
                let featureTypeObj = that._getFeatureType(featureType);
                if (featureTypeObj && featureTypeObj.listeners[event]) {
                    return featureTypeObj.listeners[event];
                }
                return null;
            },
            fire: (event, data) => {
                that.fire(event, data);
            }
        }
    },

    /**
     * 销毁
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     */
    destroy() {
        //
        ComponentBase.prototype.destroy.call(this);
    },

    /**
     * @inheritDoc
     */
    load() {
        ComponentBase.prototype.load.call(this);
        //初始化点线面图层组
        this.map.initialGroupLayers();
    },

    /**
     * @inheritDoc
     */
    unload() {
        this.removeAll();
        ComponentBase.prototype.unload.call(this);
    },

    /**
     * 添加一类业务数据
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     * @param opts {Object}
     * @param opts.featureType {String} 业务数据类型标识
     * @param opts.featureName {String} 业务数据类型名称
     * @param opts.list {Array} 业务数据列表
     */
    add(opts) {},

    /**
     * 更新数据
     * @ignore
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     * @param opts {Object}
     * @param opts.featureType {String} 业务数据类型标识
     * @param opts.list {Array} 业务数据列表
     */
    update(opts) {},


    /**
     * 清空一类业务数据（图层清空）
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     * @param featureType {String} 业务数据类型标识
     */
    clear(featureType) {
        let featureTypeObj = this._getFeatureType(featureType);
        if (featureTypeObj) {
            featureTypeObj.renderer.clear();
        }
        // 
        this._fireUpdateEvent();
    },

    /**
     * 清空所有业务数据（图层清空）
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     */
    clearAll() {
        for (let i = this.featureTypeList.length - 1; i >= 0; i--) {
            let featureTypeObj = this.featureTypeList[i];
            featureTypeObj.renderer.clear();
        }
        // 
        this._fireUpdateEvent();
    },

    /**
     * 彻底清除一类业务数据（图层移除）
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     * @param featureType {String} 业务数据类型标识
     */
    remove(featureType) {
        for (let i = 0; i < this.featureTypeList.length; i++) {
            let featureTypeObj = this.featureTypeList[i];
            if (featureTypeObj.featureType == featureType) {
                featureTypeObj.renderer.destroy();
                featureTypeObj.renderer = null;
                this.featureTypeList.splice(i, 1);
                // 
                this._fireUpdateEvent();
                break;
            }
        }
    },

    /**
     * 彻底清除所有业务数据（图层移除）
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     */
    removeAll() {
        for (let i = this.featureTypeList.length - 1; i >= 0; i--) {
            let featureTypeObj = this.featureTypeList[i];
            featureTypeObj.renderer.destroy();
            featureTypeObj.renderer = null;
            this.featureTypeList.splice(i, 1);
        }
        this.featureTypeList = [];
        // 
        this._fireUpdateEvent();
    },


    /**
     * 获取业务类型对应的图层对象
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     * @param featureType {String} 业务数据类型标识
     * @returns {g2.carto.ILayer}
     */
    getLayer(featureType) {},

    /**
     * 遍历数据
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     * @param featureType {String} 业务数据类型标识
     * @param visitor {G.render.RenderMgr~FeatureVisitor} 数据访问器
     */
    visitFeature(featureType, visitor) {},

    /**
     * 设置是否可见
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     * @param featureType {String} 业务数据类型标识
     * @param visible {Boolean} 是否显示
     */
    setVisible(featureType, visible) {
        let featureTypeObj = this._getFeatureType(featureType);
        if (featureTypeObj) {
            featureTypeObj.renderer.setVisible(!!visible);
            // 
            this._fireUpdateEvent();
            return true;
        }
        return false;
    },

    /**
     * 获取是否可见
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     * @param featureType {String} 业务数据类型标识
     */
    getVisible(featureType) {
        let featureTypeObj = this._getFeatureType(featureType);
        if (featureTypeObj) {
            return featureTypeObj.renderer.getVisible();
        }
        return undefined;
    },

    /**
     * 获取当前所有类型名称
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     */
    getFeatureTypeNames() {
        const list = [];
        for (let i = this.featureTypeList.length - 1; i >= 0; i--) {
            let featureTypeObj = this.featureTypeList[i];
            list.push(featureTypeObj.featureType);
        }
        return list;
    },

    /**
     * 监听事件
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     * @param {string} event 事件名
     * @param {Function} handler 事件处理函数
     * @param {Object} [context]
     *
     */
    on(event, handler, context) {
        this.listenEvents[event] = true;
        AppEvent.prototype.on.call(this, event, handler, context);
    },

    /**
     * 取消监听事件
     * @method
     * @memberOf  G.render.RenderMgr.prototype
     * @param {string} event 事件名
     * @param {Function} handler 事件处理函数
     *
     */
    off(event, handler) {
        AppEvent.prototype.off.call(this, event, handler);
        const handlers = this._$handlers[event];
        if (!handlers || (handlers && handlers.length == 0)){
            this.listenEvents[event] = false;
        }
    },

    /**
     * 是否监听事件
     * @ignore
     * @param {String} event 
     */
    listens(event) {
        if (this.listenEvents[event]) {
            return true;
        }
        for (let i = this.featureTypeList.length - 1; i >= 0; i--) {
            let featureTypeObj = this.featureTypeList[i];
            if (featureTypeObj.listeners && featureTypeObj.listeners.hasOwnProperty(event)) {
                return true;
            }
        }
        return false;
    },

    /**
     * 获取数据信息
     * @private
     * @param featureType
     */
    _getFeatureType(featureType) {
        for (let i = 0; i < this.featureTypeList.length; i++) {
            let featureTypeObj = this.featureTypeList[i];
            if (featureTypeObj.featureType == featureType) {
                return featureTypeObj;
            }
        }
        return null;
    },
    /**
     * @ignore
     * @param {*} event 分发变化的事件
     */
    _fireUpdateEvent(event){
        this.fire('feature-change',event);
    },
});
module.exports = component;